// config.js
const environment = process.env.REACT_APP_STAGE // 'dev', 'prod', or 'test'
  ? process.env.REACT_APP_STAGE
  : "prod";

let device = process.env.REACT_APP_DEVICE
  ? process.env.REACT_APP_DEVICE
  : "123TCS Customer Solutions";
const localUrl =
  process.env.REACT_APP_PLATFORM === "mobile"
    ? "http://10.0.2.2:5000"
    : "http://127.0.0.1:5000"; // Localhost for mobile is 10.0.2.2

device =
  environment === "dev" || environment === "test" ? `${device} (test)` : device;

// Base config
const base = {
  device,
};

// Production config
const prod = {
  ...base,
  cardbase: {
    url: "https://cardbase.123tcs.io",
  },
  admin: {
    url: "https://admin.123tcs.io",
  },
  captcha: {
    sitekey: "0d188892-b3cb-4058-a61e-fcbf966ee0a3", // TODO dotenv
  },
};

// Development config
const dev = {
  ...base,
  cardbase: {
    url: localUrl,
  },
  admin: {
    url: localUrl,
  },
  captcha: {
    sitekey: "30000000-ffff-ffff-ffff-000000000003",
  },
};

// Test config
const test = {
  ...base,
  cardbase: {
    url: "https://cardbase-test.123tcs.io",
  },
  admin: {
    url: "https://admin-test.123tcs.io",
  },
  captcha: {
    sitekey: "25340171-b342-4188-9d05-d3ba5681af97",
  },
};

const config = {
  prod,
  dev,
  test,
};

export default config[environment];
